module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/pocketwaka/3.gif?bc22f1a106e1a00d0e57788c5618e89b";